<div class="vq-dialog cmp-dialog" role="dialog" aria-labelledby="cvq-title">
  <div class="vqd-head">
    <div class="t">
      <h2 id="cvq-title">Compare before you apply</h2>
      <p>Left is what the proposal has now. Right is what <b>{{ plan.label }}</b> would put in. Changed values are highlighted.</p>
    </div>
    <button type="button" class="vqd-x" (click)="cancel()" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>

  <div class="vqd-body">
    <!-- H1: totals -->
    <div class="cmp-tot">
      <div><span>Material cost now</span><b class="num">{{ before.cost | currency }}</b></div>
      <div class="arw"><mat-icon>arrow_forward</mat-icon></div>
      <div><span>After applying</span><b class="num">{{ after.cost | currency }}</b></div>
      <div class="dl" [class.dn]="costDiff < 0" [class.up]="costDiff > 0">
        <span>Difference</span>
        <b class="num">{{ costDiff === 0 ? '$0.00' : (costDiff < 0 ? '−' : '+') + (absolute(costDiff) | currency) }}</b>
      </div>
      <p class="ft">Proposal total with profit: <b class="num">{{ before.sell | currency }}</b> → <b class="num">{{ after.sell | currency }}</b>
        ({{ sellDiff < 0 ? '−' : '+' }}{{ absolute(sellDiff) | currency }})</p>
    </div>

    <!-- H2 / H3: rows -->
    <div class="cmp-wrap">
      <table class="cmp">
        <thead>
          <tr><th>Material</th><th class="c-now">In proposal now</th><th class="c-new">From vendor quote</th><th class="r">Difference</th></tr>
        </thead>
        <tbody>
          @for (c of rows; track trackByRow($index, c)) {
            @let lbl = changeLabel(c);
            <tr [ngClass]="'r-' + lbl.cls">
              <td>
                <span class="lbl" [ngClass]="'l-' + lbl.cls">{{ lbl.text }}</span>
                <b class="mn">{{ c.before ? c.before.name : c.after?.name }}</b>
                @if (renamed(c)) { <span class="ren">becomes {{ c.after?.name }}</span> }
              </td>
              <td class="c-now">
                @if (c.before; as b) {
                  <span class="qx">{{ b.qty }} × {{ b.unitCost | currency }}</span>
                  <span class="vx">{{ b.vendorName || 'No vendor' }}</span>
                } @else {
                  <span class="none">Not in proposal</span>
                }
              </td>
              <td class="c-new">
                @if (c.kind === 'missing') {
                  <span class="none">This quote does not include it</span>
                  <span class="seg2" role="group" [attr.aria-label]="'Keep or remove ' + c.before?.name">
                    <button type="button" [attr.aria-pressed]="!c.remove" (click)="setRemove(c, false)">Keep</button>
                    <button type="button" [attr.aria-pressed]="!!c.remove" (click)="setRemove(c, true)">Remove</button>
                  </span>
                } @else if (c.after; as a) {
                  <span class="qx">
                    @if (changed(c, 'qty')) { <mark>{{ a.qty }}</mark> } @else { {{ a.qty }} }
                    ×
                    @if (changed(c, 'unitCost')) { <mark>{{ a.unitCost | currency }}</mark> } @else { {{ a.unitCost | currency }} }
                  </span>
                  <span class="vx">@if (changed(c, 'vendorName')) { <mark>{{ a.vendorName }}</mark> } @else { {{ a.vendorName }} }</span>
                  <span class="srcq">{{ a.quoteSource }}@if (c.note) { · {{ c.note }}}</span>
                }
              </td>
              <td class="r">
                @let d = lineDiff(c);
                @if (d === 0) { <span class="df0">—</span> } @else {
                  <span class="dfv" [class.dn]="d < 0" [class.up]="d > 0">{{ d < 0 ? '−' : '+' }}{{ absolute(d) | currency }}</span>
                }
              </td>
            </tr>
          }
        </tbody>
        <tfoot>
          <tr><td colspan="3">Material cost</td>
            <td class="r">
              @if (costDiff === 0) { <span class="df0">—</span> } @else {
                <span class="dfv" [class.dn]="costDiff < 0" [class.up]="costDiff > 0">{{ costDiff < 0 ? '−' : '+' }}{{ absolute(costDiff) | currency }}</span>
              }
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <!-- H4 -->
  <div class="vqd-foot">
    <span class="note">Nothing changes until you apply. You can undo afterwards.</span>
    <button type="button" class="vqd-btn" (click)="back()">Back</button>
    <button type="button" class="vqd-btn" (click)="cancel()">Cancel</button>
    <button type="button" class="vqd-btn vqd-btn-go" (click)="apply()" matTooltip="Updates the proposal materials as shown above.">Apply Changes</button>
  </div>
</div>
